import swiperSlider from './components/swiper';

// Slider configs
const heroConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 0,
	autoplay: {
		enabled: true,
		delay: 5000,
	},
	speed: 500,
	loop: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
};

const newsConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 32,
	autoplay: {
		enabled: true,
		delay: 5000,
	},
	speed: 500,
	loop: true,
	grabCursor: true,
	navigation: {
		nextEl: '.news-button-next',
		prevEl: '.news-button-prev',
	},
};

function allPages() {
	document.querySelector('.hero-slider') &&
		swiperSlider('.hero-slider', heroConfig);

	document.querySelector('.swiper-news') &&
		swiperSlider('.swiper-news', newsConfig);
}

async function documentacao() {
	await import('./ajax/ajax-docs');
}

async function news() {
	await import('./ajax/ajax-posts');
}

function initDOMLoaded() {
	document.removeEventListener('DOMContentLoaded', initDOMLoaded);
	allPages();
	document.querySelector('.post-type-archive-documento') && documentacao();
	document.querySelector('.blog') && news();
}

// Code runs after page loaded
document.addEventListener('DOMContentLoaded', initDOMLoaded);
